import React from 'react'
import { useQuery } from '@apollo/react-hooks'
import { useTranslation } from 'react-i18next'
import FolderTree, { type FolderTreeNode } from '@/components/doc-control/FolderTree'
import FolderTreeSkeleton from '@/components/doc-control/FolderTreeSkeleton'

import * as Query from '../../../api/gql/query'

interface FolderPickerProps {
  projectId: string
  value: string | null
  onChange: (folderId: string) => void
}

/**
 * Doc Control destination-folder picker, shared by ConsolidateDialog's
 * "publish now" section, PublishDialog and WorkflowTemplateDialog. Fetches the
 * project's folder tree and renders the shared FolderTree that the document
 * picker (DocumentSelectorModal) and the move dialog use too.
 */
const FolderPicker: React.FC<FolderPickerProps> = ({ projectId, value, onChange }) => {
  const { t } = useTranslation()
  const { data, loading } = useQuery(Query.DOC_FOLDER_TREE, {
    variables: { projectId },
    skip: !projectId,
  })
  const folders: FolderTreeNode[] = data?.docFolderTree || []

  return (
    // p-1.5 (not p-1): the 2px focus ring needs room inside the border, or it
    // touches and clips at the scroll edge.
    <div className="max-h-56 overflow-y-auto rounded-md border p-1.5">
      {loading ? (
        <FolderTreeSkeleton />
      ) : (
        <FolderTree folders={folders} selectedId={value} onSelect={onChange} aria-label={t('DocControl_select_folder')} />
      )}
    </div>
  )
}

export default FolderPicker
